import TimeAgoMinutes from "./TimeAgoMinutes";
import subjects from "../../data/subjects";
import { sendMessage } from "../../wsFunctions/socket";

function HelpingList(props) {
    const helping = props.helping;
    const colorRemove = {backgroundColor: "rgb(255, 99, 88)"};
    const colorAdd = {backgroundColor: "rgb(124, 220, 124)"};
    const colorDone = {backgroundColor: "rgb(100, 159, 204)"};

    //KUNNE SENDE VIA WEBSOCKET, HVILKET TALL SOM SKAL FJERNES ELLER FLYTTES TIL PÅGÅENDE
    const removeRequest = (userID, timestamp) => {
        props.setLoading(() => (true));
        sendMessage({type: "help-request-remove", data: {userID: userID, timestamp: timestamp}});
    };
    const answerRequest = (userID, timestamp) => {
        props.setLoading(() => (true));
        sendMessage({type: "help-request-answer", data: {userID: userID, timestamp: timestamp}})
    };

    return (
        <div className="requests-container-helper-page">
            {props.list.map((request, i) => {
                let subject = request.subject;
                subjects.forEach((grade) => {
                    grade.subjects.forEach((sub) => {
                        if (sub.value === subject) {
                            subject = sub.text;
                        };
                    });
                });
                
                return (
                    <div key={i} className="request-container-helper-page">
                        <div className="request-top-layer-helper-page">
                            <p><b>Sted:</b> {request.location[0]} {request.location[1]}</p>
                            <p><TimeAgoMinutes timestamp={request.timestamp} /> minutter siden</p>
                        </div>
                        <div className="request-middle-layer-helper-page">
                            <p><b>Fag:</b> {subject}</p>
                            <p><b>ID: </b> {request.userID}</p>
                        </div>
                        <div className="request-bottom-layer-helper-page">
                            { (request.offline && !helping)
                            ? <p style={{color: "crimson"}}>Bruker frakoblet (sletting avventes)</p>
                            : <>
                                <button onClick={helping ? () => {removeRequest(request.userID, request.timestamp)} : () => {answerRequest(request.userID, request.timestamp)}} style={(helping ? colorDone : colorAdd)}>{(helping ? "Ferdig" : "På vei")}</button>
                                <button onClick={() => {removeRequest(request.userID, request.timestamp)}} style={(helping ? {display: "none"} : colorRemove)}>Fjern</button>
                            </>
                            }
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default HelpingList;